import React from "react";
import { useTranslation } from "react-i18next";
import MomentUtils from "@date-io/moment";
import moment, { Moment } from "moment";
import { toast } from "react-toastify";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from "@material-ui/pickers";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datePickerRoot: {
      width: "125px",
    },
    datePickerContainer: {
      display: "flex",
      justifyContent: "space-around",
    },
  })
);

interface Props {
  startDate: Moment;
  endDate: Moment;
  onStartDateChange: (newValue: Moment) => void;
  onEndDateChange: (newValue: Moment) => void;
}

const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={moment.locale()}>
        <Grid container className={classes.datePickerContainer}>
          <DatePicker
            className={classes.datePickerRoot}
            autoOk
            variant="inline"
            margin="dense"
            openTo="date"
            label={t("StartDate")}
            value={startDate}
            onChange={(newValue: any) => {
              onStartDateChange(newValue);
            }}
            inputVariant="outlined"
            format="L"
          />
          <TimePicker
            className={classes.datePickerRoot}
            autoOk
            variant="inline"
            margin="dense"
            openTo="hours"
            label={t("StartTime")}
            value={startDate}
            onChange={(newValue: any) => {
              onStartDateChange(newValue);
            }}
            inputVariant="outlined"
            format="hh:mm a"
            minutesStep={5}
          />
        </Grid>
        <Grid container justify="center">
          <Typography variant="body2">{t("to")}</Typography>
        </Grid>
        <Grid container className={classes.datePickerContainer}>
          <DatePicker
            className={classes.datePickerRoot}
            autoOk
            variant="inline"
            margin="dense"
            openTo="date"
            label={t("EndDate")}
            value={endDate}
            onChange={(newValue: any) => {
              onEndDateChange(newValue);
            }}
            inputVariant="outlined"
            format="L"
          />
          <TimePicker
            className={classes.datePickerRoot}
            autoOk
            variant="inline"
            margin="dense"
            openTo="hours"
            label={t("EndTime")}
            value={endDate}
            onChange={(newValue: any) => {
              onEndDateChange(newValue);
            }}
            inputVariant="outlined"
            format="hh:mm a"
            minutesStep={5}
          />
        </Grid>
      </MuiPickersUtilsProvider>
    </Grid>
  );
};

export default DateRangePicker;
